import axios from 'axios';
import { adminPath } from 'common/const/path.const';

export const handlersTransport = {
  getScoringHandlerOptions: (): Promise<string[]> => axios.get(`${adminPath}/scoring-handler`),
  getExecutionHandlerOptions: (): Promise<string[]> => axios.get(`${adminPath}/execution-handler`),
  getReportHandlerOptions: (): Promise<string[]> => axios.get(`${adminPath}/report-handler`),
};
